// export function stripNonNumerics(input: string): string {
//   return `${input}`.replace(/\D/g, '');
// }

// const VERIFICATION_SMS_CODE_REGEX = /^\d{7}$/;
// const VERIFICATION_TOTP_CODE_REGEX = /^\d{6}$/;

// export function isValidVerificationCode(smsCode: string): boolean {
//   return VERIFICATION_SMS_CODE_REGEX.test(smsCode);
// }

// export function isValidTotpVerificationCode(totpCode: string): boolean {
//   return VERIFICATION_TOTP_CODE_REGEX.test(totpCode);
// }

// // US format only
// export function isValidPhoneNumber(phoneNumber: string): boolean {
//   // Trim instead of clean since non-numerics that don't follow our own format need to return false
//   const trimmed = phoneNumber.trim();

//   // First check to see if it matches our own format
//   const matchFormatted = trimmed.match(/^\((\d{3})\) (\d{3})-(\d{4})$/);
//   if (matchFormatted) return true;

//   // Otherwise, check to see that it only contains 10 numeric chars
//   return /^\d{10}$/.test(trimmed);
// }

// TODO: IDFE-1212 This function throws false negatives
export function isValidEmail(email: string): boolean {
  const trimmed = email.trim();
  if (!trimmed) return false;

  const emailRegex =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line no-useless-escape
  return emailRegex.test(trimmed);
}

// export function enumConverter(str: string): string {
//   return str.toLowerCase().replace('_', '-');
// }

// export function minimizeString(value: string, size = 10): string {
//   const firstPart = value.substr(0, size / 2);
//   const lastPart = value.substr(value.length - size / 2);
//   return value.length > size ? `${firstPart}...${lastPart}` : value;
// }

// export function isValidUrl(value: string): boolean {
//   if (!value || value.trim().length === 0) return false;

//   try {
//     // eslint-disable-next-line no-new
//     new URL(value);
//     return true;
//   } catch (exception) {
//     return false;
//   }
// }

// // Method returns true if passed in string is a valid *.coinbase.com or *.cbhq.net URL, otherwise false
// export function isCoinbaseUrl(value: string): boolean {
//   if (!value || value.trim().length === 0) return false;

//   try {
//     const parsedUrl = new URL(decodeURIComponent(value));
//     if (!parsedUrl) return false;

//     const splitHostname = parsedUrl.hostname.split('.');
//     if (splitHostname.length < 2) return false;

//     return (
//       (splitHostname[splitHostname.length - 2] === 'coinbase' &&
//         splitHostname[splitHostname.length - 1] === 'com') ||
//       (splitHostname[splitHostname.length - 2] === 'cbhq' &&
//         splitHostname[splitHostname.length - 1] === 'net')
//     );
//   } catch (exception) {
//     return false;
//   }
// }

// export function getCookieValue(searchString: string, cookieName: string) {
//   const regex = new RegExp(`(?<=\\b${cookieName}=)[^;]+`);
//   const match = searchString.match(regex);

//   if (match === null || cookieName === '') {
//     return null;
//   }

//   return match[0];
// }
